@if (eventTimetable && (!event?.isGeneric() || isCardView)) {
  <div
    class="timetable"
    [class.border-top]='!isCardView'
    [class.full-width]='isWeddingPage'
    [class.border-top-none]="
      (eventType !== EventType.SPORTPAGE &&
        eventType !== EventType.LANDINGPAGE) ||
      isUaEvent
    "
    [class.edit-mode]='isEdit'
    [class.wedding-page]='layout === EventTemplateLayout.ONE_COLUMN_ELEGANT || layout === EventTemplateLayout.ONE_COLUMN_MODERN'
  >
    @for (item of filteredItems; track item.id) {
      @if(isEdit){
        <div class='update-actions-menu'>
          <app-event-section-timetable-item
            [item]="item"
            [eventType]="eventType"
            [isUaEvent]="isUaEvent"
            [class.dashed-bordered]='isWeddingPage'
            [class.selected]='item === selectedItem'
            [event]='event'
            [index]="$index"
            [last]='filteredItems !== undefined && $index === filteredItems.length - 1'
            (click)='selectItem(item)'
          >
          </app-event-section-timetable-item>
          @if(isWeddingPage){
            @if(item === selectedItem){
              <div
                class='menu-trigger transparent'
                [ngStyle]='{
                "color": bodyColor
                }'
                [matMenuTriggerFor]="menu">
                <i class="far fa-ellipsis-v"></i>
              </div>
            }
          }@else{
            <div
              class='menu-trigger'
              [matMenuTriggerFor]="menu">
              <i class="far fa-ellipsis-v"></i>
            </div>
          }
          <mat-menu #menu="matMenu" class="table-actions-container">
            <button mat-menu-item (click)='onUpdate(UpdateActions.EDIT, item)'>
                <span class="menu-item-content">
                  <i class="far fa-pen"></i>
                  <span class="text">{{ 'APP.EDIT' | translate | camelCase }}</span>
                </span>
            </button>

            <button mat-menu-item (click)='onUpdate(UpdateActions.DELETE, item)'>
                <span class="menu-item-content">
                  <i class="far fa-trash"></i>
                  <span class="text"
                  >{{ 'APP.DELETE' |
                    translate | camelCase }}</span
                  >
                </span>
            </button>
          </mat-menu>
        </div>
      } @else {
        <app-event-section-timetable-item
          [item]="item"
          [eventType]="eventType"
          [isUaEvent]="isUaEvent"
          [event]='event'
          [index]="$index"
          [last]='filteredItems !== undefined && $index === filteredItems.length - 1'
        >
        </app-event-section-timetable-item>
      }

    }

    @if(layout === EventTemplateLayout.ONE_COLUMN_MODERN){
      <div class="line"></div>
    }
  </div>
}
@if(eventTimetable && event?.isGeneric() && !isCardView){
    <cdk-accordion
      class="example-accordion"
    >
      @for (item of filteredItems; track item.id) {
        <cdk-accordion-item
          #accordionItem="cdkAccordionItem"
          class="example-accordion-item"
          [class.preview]="!isEdit"
          [class.generic]="event?.type === EventType.GENERIC_LANDINGPAGE || event?.type === EventType.GENERIC_EVENT"
          [style.border-color]="event?.type === EventType.GENERIC_LANDINGPAGE || event?.type === EventType.GENERIC_EVENT ? bodyColor : ''"
          [style.color]="event?.type === EventType.GENERIC_LANDINGPAGE || event?.type === EventType.GENERIC_EVENT ? bodyColor : ''"
          role="button"
          tabindex="0"
          [attr.id]="'accordion-header-' + $index"
          [attr.aria-expanded]="accordionItem.expanded"
          [attr.aria-controls]="'accordion-body-' + $index"
        >
          <div
            class="example-accordion-item-header"
            (click)="accordionItem.toggle()"
          >
            @if(!showOnlyTitle){
              {{ item.timeFrom }} - {{ item.timeTo}} -
            }
            {{item.title}}
            <div class="actions"
                 [ngStyle]="{
                  'color': bodyColor,
                }">
              @if (isEdit) {
                <span (click)='onUpdate(UpdateActions.EDIT, item)'>
                <i class="far fa-pen"></i>
              </span>
                <span (click)='onUpdate(UpdateActions.DELETE, item)'>
                <i class="far fa-trash"></i>
              </span>
              }
              <span class="example-accordion-item-arrow">
          <i
            class="far fa-chevron-{{
                    accordionItem.expanded ? 'up' : 'down'
                  }}"
          ></i>
            </span>
            </div>
          </div>
          <div
            class="example-accordion-item-body"
            role="region"
            [style.display]="accordionItem.expanded ? '' : 'none'"
            [attr.id]="'accordion-body-' + $index"
            [attr.aria-labelledby]="'accordion-header-' + $index"
            [innerHtml]="item.description | safeHtml"
          ></div>
        </cdk-accordion-item>
      }
    </cdk-accordion>

}
